import { clear_token } from "@/router";
import { client_domain } from "@/main.js";

const SIDEBAR_ROUTE_PARENT_PATHS = {
  manage_portal: '/create_portal',
  view_portal: '/create_portal',
  publish_portal: '/create_portal',
  view_report_topic: '/create_report',
  view_report_tag: '/create_report',
  view_full_report: '/create_report',
  view_group: '/create_group',
  view_all_groups: '/create_group',
  manage_event: '/events',
  ticket_dashboard: '/events',
  get_rsvps: '/manage_rsvps',
  organisation_create_membership: '/create_membership',
  view_membership: '/create_membership',
  view_membership_users: '/create_membership',
  manage_membership: '/create_membership',
  donation_campaigns: '/donation_campaigns_dashboard',
  my_donation_campaigns: '/donation_campaigns_dashboard',
  donation_history: '/donation_campaigns_dashboard',
  ProductView: '/manage_catalogue',
  my_shop: '/manage_catalogue',
  my_services: '/manage_services',
  create_form_tab: '/create_form',
  create_section: '/manage_sections',
  assign_sections: '/manage_sections',
  assign_questions: '/manage_questions',
  community_asset: '/create_assets',
  organisation_manage_incidents: '/manage_incidents',
};

const SIDEBAR_PATH_PARENT_SECTIONS = {
  '/create_user': 'user_management',
  '/view_business_dashboard': 'user_management',
  '/create_portal': 'portal_management',
  '/create_report': 'portal_management',
  '/create_group': 'portal_management',
  '/events': 'events_management',
  '/manage_rsvps': 'events_management',
  '/create_membership': 'membership_management',
  '/donation_campaigns_dashboard': 'donation_management',
  '/manage_catalogue': 'marketplace_management',
  '/manage_services': 'marketplace_management',
  '/manage_promotions': 'marketplace_management',
  '/create_form': 'form_management',
  '/manage_sections': 'form_management',
  '/manage_questions': 'form_management',
  '/create_assets': 'community_management',
  '/create_survey': 'community_management',
  '/create_discussion': 'community_management',
  '/create_polls': 'community_management',
  '/manage_incident_types': 'incident_management',
  '/manage_incidents': 'incident_management',
};

const SIDEBAR_OPEN_SECTION_KEY = 'admin_sidebar_open_section';

export default {
    props: {
      variant: {
        type: String,
        default: 'desktop',
      },
      offcanvas_id: {
        type: String,
        default: 'offcanvasExample',
      },
    },
    mounted() {
      this.restore_sidebar_section();
      this.initSidebar();
      this.$el.addEventListener('click', this.closeMobileSidebarOnNavigation);
      if (!this.isMobile && window.MutationObserver) {
        this.sidebarClassObserver = new MutationObserver(() => {
          const isExternallyClosed = this.$el.classList.contains('close');
          if (this.isClosed !== isExternallyClosed) {
            this.isClosed = isExternallyClosed;
          }
        });
        this.sidebarClassObserver.observe(this.$el, { attributes: true, attributeFilter: ['class'] });
      }
      if(client_domain.includes('cbo')){
        this.cbo_domain=true
      }
      if(client_domain.includes('cbo')){
        this.cbo_domain=true
      }
      if (client_domain.includes('workbook')) {
        this.workbook_domain = true;
      }
      if (client_domain.includes('chiefluthuli')){
        this.school_domain = true;
      }
      if (client_domain.includes('dwypd') || client_domain.includes('soulcity') || client_domain.includes('nsp')) {
        this.dwypd_domain = true;
      }
      this.centerActiveNavigationItem();
    },

  data() {
    return ({
      isClosed: false,
      cbo_domain:false,
      workbook_domain: false,
      school_domain: false,
      dwypd_domain: false,
      open_sidebar_section: 'user_management',
      sidebarClassObserver: null,
    });
  },

    inject: ['client_features'],
    computed: {
      isMobile() {
        return this.variant === 'mobile';
      },
    },
    watch: {
      '$route.fullPath'() {
        this.open_active_route_sidebar_section();
        this.centerActiveNavigationItem();
      },
      isClosed(isClosed) {
        if (!isClosed) {
          this.centerActiveNavigationItem();
        }
      },
    },
    beforeDestroy() {
      this.destroySidebarListeners();
    },
    beforeUnmount() {
      this.destroySidebarListeners();
    },
    methods: {
      destroySidebarListeners() {
      this.$el.removeEventListener('click', this.closeMobileSidebarOnNavigation);
      if (this.sidebarClassObserver) {
        this.sidebarClassObserver.disconnect();
        this.sidebarClassObserver = null;
      }
      },
      toggle() {
        this.isClosed = !this.isClosed;
      },
      is_sidebar_section_open(section_key) {
        return this.isClosed || this.open_sidebar_section === section_key;
      },
      toggle_sidebar_section(section_key) {
        this.open_sidebar_section = section_key;
        this.save_sidebar_section(section_key);
      },
      restore_sidebar_section() {
        const active_section = this.get_active_sidebar_section();
        const stored_section = localStorage.getItem(SIDEBAR_OPEN_SECTION_KEY);
        this.open_sidebar_section = active_section || stored_section || 'user_management';
      },
      save_sidebar_section(section_key) {
        localStorage.setItem(SIDEBAR_OPEN_SECTION_KEY, section_key);
      },
      open_active_route_sidebar_section() {
        const active_section = this.get_active_sidebar_section();
        if (!active_section) return;
        this.open_sidebar_section = active_section;
        this.save_sidebar_section(active_section);
      },
      get_active_sidebar_section() {
        return SIDEBAR_PATH_PARENT_SECTIONS[this.get_active_sidebar_path()]
          || SIDEBAR_PATH_PARENT_SECTIONS[this.$route.path]
          || '';
      },
      centerActiveNavigationItem() {
        this.$nextTick(() => {
          const scrollArea = this.$refs.sidebarScrollArea;
          if (!scrollArea) return;

          this.sync_sidebar_active_state(scrollArea);

          const activeLink = scrollArea.querySelector(
            '.sidebar-route-active, .router-link-exact-active, .router-link-active, .nav-link.bg-primary'
          );
          if (!activeLink) return;

          const activeCenter = activeLink.offsetTop + (activeLink.offsetHeight / 2);
          const scrollTop = activeCenter - (scrollArea.clientHeight / 2);

          scrollArea.scrollTo({
            top: Math.max(0, scrollTop),
            behavior: 'smooth'
          });
        });
      },
      get_active_sidebar_path() {
        return SIDEBAR_ROUTE_PARENT_PATHS[this.$route.name] || this.$route.path;
      },
      getLinkPath(link) {
        return new URL(link.href, window.location.origin).pathname;
      },
      sync_sidebar_active_state(scroll_area) {
        const activePath = this.get_active_sidebar_path();
        const links = scroll_area.querySelectorAll('a.nav-link');

        links.forEach((link) => {
          const isActive = this.getLinkPath(link) === activePath;
          link.classList.toggle('sidebar-route-active', isActive);
          link.classList.toggle('bg-primary', isActive);
          link.classList.toggle('text-white', isActive);
        });
      },
      initSidebar() {
        let arrows = document.querySelectorAll(".arrow");
        arrows.forEach(arrow => {
          arrow.addEventListener("click", (e) => {
            let arrowParent = e.target.parentElement.parentElement;
            arrowParent.classList.toggle("show-menu");
          });
        });
      },
      log_out(){
        clear_token()
        this.$router.push({ path:'/',});
      },
      closeMobileSidebarOnNavigation(event) {
        if (!this.isMobile || !event.target.closest('a')) {
          return;
        }

        const offcanvas = window.bootstrap?.Offcanvas?.getInstance(this.$el);
        if (offcanvas) {
          offcanvas.hide();
        }
      }
    }
  }
